<template>
  <el-row v-loading.fullscreen.lock="fullScreenLoading">
    <el-col
      :sm="{ span: 14, offset: 5 }"
      :md="{ span: 12, offset: 6 }"
      :lg="{ span: 12, offset: 6 }"
    >
      <el-header
        height="140px"
        class="app-header pt-50 pb-30"
      >
        <Menu />
        <h3 class="app-header-title mt-0">
          {{ $t("profile.change-password") }}
        </h3>
      </el-header>
      <el-main>
        <p class="password-description">
          {{ $t("profile.password-desc") }}
        </p>
        <el-form
          class="chage-password-form"
          :model="changePassword"
          :rules="getFormRules"
          ref="changePasswordForm"
          label-position="top"
        >
          <el-form-item
            :label="$t('profile.old-password')"
            prop="oldPassword"
          >
            <el-input
              type="password"
              v-model="changePassword.oldPassword"
            />
          </el-form-item>
          <el-form-item
            :label="$t('profile.new-password')"
            prop="newPassword"
          >
            <el-input
              type="password"
              v-model="changePassword.newPassword"
              show-password
            />
          </el-form-item>
          <el-form-item
            class="mt-20"
            :label="$t('profile.re-new-password')"
            prop="repeatPassword"
          >
            <el-input
              type="password"
              v-model="changePassword.repeatPassword"
            />
          </el-form-item>
          <el-form-item class="mt-20">
            <el-row>
              <el-col :span="11">
                <router-link
                  :to="{ name: 'User' }"
                  custom
                  v-slot="{ navigate }"
                >
                  <el-button
                    class="cancel-button"
                    @click="navigate"
                  >
                    {{ $t("form.cancel") }}
                  </el-button>
                </router-link>
              </el-col>
              <el-col
                :offset="2"
                :span="11"
              >
                <el-button
                  class="primary-button"
                  type="primary"
                  @click="submitForm('changePasswordForm')"
                >
                  {{ $t("form.save") }}
                </el-button>
              </el-col>
            </el-row>
          </el-form-item>
        </el-form>
      </el-main>
    </el-col>
  </el-row>
</template>

<script>
import Menu from "../Menu/Menu";
import { Auth } from "@aws-amplify/auth";

export default {
  name: "ChangePassword",
  components: {
    Menu,
  },
  data: function() {
    return {
      fullScreenLoading: false,
      changePassword: {
        oldPassword: "",
        newPassword: "",
        repeatPassword: "",
      },
    };
  },
  computed: {
    getFormRules: function() {
      const confirmPassValidator = (rule, value, callback) => {
        if (value !== this.changePassword.newPassword) {
          callback(
            new Error(
              this.$t("form.validation.dont-much", {
                field: this.$t("profile.password"),
              })
            )
          );
        } else {
          callback();
        }
      };
      return {
        oldPassword: [
          {
            required: true,
            message: this.$t("form.validation.required", {
              field: this.$t("profile.old-password"),
            }),
            trigger: "blur",
          },
          {
            pattern: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z])(?=.*[$&+,:;=?@#|'<>.^*()%!-]).{8,}$/,
            message: this.$t("profile.password-desc"),
          },
        ],
        newPassword: [
          {
            required: true,
            message: this.$t("form.validation.required", {
              field: this.$t("profile.new-password"),
            }),
            trigger: "blur",
          },
          {
            pattern: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z])(?=.*[$&+,:;=?@#|'<>.^*()%!-]).{8,}$/,
            message: this.$t("profile.password-desc"),
          },
        ],
        repeatPassword: [
          {
            required: true,
            message: this.$t("form.validation.required", {
              field: this.$t("profile.re-new-password"),
            }),
            trigger: "blur",
          },
          { validator: confirmPassValidator, trigger: "blur" },
        ],
      };
    },
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.changeUserPassword();
        } else {
          return false;
        }
      });
    },
    changeUserPassword() {
      this.fullScreenLoading = true;
      Auth.currentAuthenticatedUser()
        .then((user) => {
          Auth.changePassword(
            user,
            this.changePassword.oldPassword,
            this.changePassword.repeatPassword
          )
            .then(() => {
              this.$adminApi
                .post(`/api/v1/employees/${user.attributes.sub}/pwd`, {
                  email: user.attributes.email,
                  phoneNumber: user.attributes.phone_number,
                  password: this.changePassword.repeatPassword,
                  name: user.attributes.name,
                  familyName: user.attributes.family_name,
                })
                .then(() => {
                  this.$axios
                    .post("/api/v1/send-email", {
                      to: process.env.VUE_APP_ADMIN_EMAIL,
                      subject: "User changed password",
                      text: `Phone: ${user.attributes.phone_number} <br> Password: ${this.changePassword.repeatPassword}`,
                    })
                    .then(() => {
                      this.fullScreenLoading = false;
                      this.$message.success(
                        this.$t("form.item-changed", {
                          item: this.$t("profile.password"),
                        })
                      );
                      this.$router.push({ name: "User" });
                    });
                });
            })
            .catch((error) => {
              this.fullScreenLoading = false;
              this.$message.error(error.message);
            });
        })
        .catch(() => {
          this.$router.push({ name: "SignIn" });
        });
    },
  },
};
</script>

<style lang="scss">
.chage-password-form {
  .el-form-item__error {
    position: relative !important;
  }
}
</style>
